import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

function CategoryMaterial() {
    return (
        <SettingsMetaData propertyName={"MatrialCategory"} viewPropertyName={"Category"} />
      );
}

export default CategoryMaterial
